document.addEventListener('DOMContentLoaded', () => {
  $('.select').on('changed.bs.select', (event, currentIndex, isSelected) => {
    if (currentIndex) event.target.options[currentIndex].selected = isSelected;
  });
});
